(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product_recommendations_home"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendationsHome extends HTMLElement {
    constructor() {
      super();
      this.element = this;
      this.carouselElement = this.element.querySelector(".swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
      new AddToCart(this.element)
    }
  }

  customElements.define('product-recommendations-home', ProductRecommendationsHome);

  } catch(e) { console.error(e); }
})();
})();
